export const RESOLUTION_2275_2023 = "RESOLUTION_2275_2023";
export const RESOLUTION_3374_2000 = "RESOLUTION_3374_2000";
